// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a016acc","455":"7674faf2","977":"24738865"}[chunkId] + ".chunk.js";
};